import Modal from '@components/modal'
import Image from '@components/image'
import Button from '@components/button'
import Column from '@components/column'
import Typography from '@components/typography'
import Svg from '@components/svg'
import {
  FC,
  Dispatch,
  SetStateAction,
  useEffect,
  Fragment,
  useState,
} from 'react'
import { Category } from '@apis'
import { useSelector } from 'react-redux'
import {
  StyleGrid,
  StyleGridItem,
  StyleCheckedIconWrapper,
  StyleSearchWrapper,
  StyleSearchInput,
} from './style'

interface ChooseCategoriesProps {
  selectedItems?: any[]
  visible?: boolean
  setVisible?: Dispatch<SetStateAction<Boolean>>
  onClick?: (item: any) => void
  selector: string
  type: string
  title: string
}
const ChooseCategories: FC<ChooseCategoriesProps> = ({
  selectedItems,
  visible,
  setVisible,
  onClick,
  selector,
  type,
  title,
}) => {
  const { data: categories } = useSelector((state: any) => state[selector])
  const [search, setSearch] = useState('')
  const fetchCategories = async () => {
    await Category.list({
      state: selector,
      params: {
        type: type,
      },
    }).catch(() => {})
  }

  const handleChoose = (event) => {
    const id = (event.target as HTMLElement)
      .closest('[data-id]')
      ?.getAttribute('data-id')
    if (!!id) {
      !!onClick && onClick(categories[id])
    }
  }

  useEffect(() => {
    if (!categories?.length) {
      fetchCategories()
    }
  }, [])

  return (
    <Modal
      visible={visible}
      onClose={() => {
        setVisible(false)
      }}
      width={'50%'}
    >
      <Column>
        <Typography
          content={`Add ${title}`}
          weight={400}
          tc="primary"
          styleText="margin-bottom:20px;text-align:center;"
        />
      </Column>
      <Typography
        content={`Select ${title}`}
        weight={400}
        tc="primary"
        styleText="margin-bottom:20px;"
      />
      <StyleSearchWrapper>
        <Svg svg="search" color={'inputBorder'} />
        <StyleSearchInput
          onChange={(event: any) => {
            setSearch(event.target.value)
          }}
          placeholder="Search..."
        />
      </StyleSearchWrapper>
      <StyleGrid onClick={handleChoose}>
        {categories
          ?.filter((category: any) => category.name.includes(search))
          ?.map((category: any, index: number) => {
            const findIndex = selectedItems?.findIndex(
              (item: any) => item.id == category.id,
            )
            return (
              <Fragment key={category?.id}>
                <StyleGridItem data-id={index}>
                  <Image
                    width={50}
                    height={50}
                    styleImage={`border-radius:50%;`}
                    src={`${process.env.BUCKET_URL}/${category?.infos?.image}`}
                  />
                  <Typography
                    content={category?.name}
                    size={12}
                    styleText="text-align:center"
                  />
                  {findIndex >= 0 && (
                    <StyleCheckedIconWrapper>
                      <Svg svg="circleTick" color={'secondary'} />
                    </StyleCheckedIconWrapper>
                  )}
                </StyleGridItem>
              </Fragment>
            )
          })}
      </StyleGrid>
      <Column alignItems="flex-end">
        <Button
          title={`Add ${type}`}
          height={45}
          onClick={() => {
            setVisible(false)
          }}
        />
      </Column>
    </Modal>
  )
}

export default ChooseCategories
